import { render } from "./ReminderDialog.vue?vue&type=template&id=4451e352&scoped=true"
import script from "./ReminderDialog.vue?vue&type=script&lang=js"
export * from "./ReminderDialog.vue?vue&type=script&lang=js"

import "./ReminderDialog.vue?vue&type=style&index=0&id=4451e352&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4451e352"]])

export default __exports__